module.exports = __webpack_public_path__ + "img/n-001.prt.aff7774d.jpg";